export const getTableView = (plug) => class TableView {
    constructor(node, cellMinWidth) {
        this.node = node;
        this.cellMinWidth = cellMinWidth;
        this.dom = document.createElement('div');
        this.table = this.dom.appendChild(document.createElement('table'));
        this.colgroup = this.table.appendChild(document.createElement('colgroup'));
        updateColumns(node, this.colgroup, this.table, cellMinWidth);
        this.contentDOM = this.table.appendChild(document.createElement('tbody'));
        this.dom.addEventListener('mousedown', (e) => {
            const target = e.target;
            if (e.button === 2 && (target === null || target === void 0 ? void 0 : target.closest('.selectedCell'))) {
                e.preventDefault();
            }
        });
        // legacy contextmenu
        this.dom.addEventListener('contextmenu', (e) => {
            var _a, _b;
            e.preventDefault();
            e.stopPropagation();
            const t = plug.editor.t.bind(plug.editor);
            const supportsCSSMin = (_b = (_a = window.CSS) === null || _a === void 0 ? void 0 : _a.supports) === null || _b === void 0 ? void 0 : _b.call(_a, 'transform: translateX(min(1px, calc(1vw - 1%)))');
            const menu = document.createElement('div');
            menu.id = 'exeditor-context-menu';
            menu.style.cssText = `
          position: fixed;
          margin: 0;
          left: -2px;
          top: -2px;
          border: 2px transparent solid;
          z-index: var(--exeditor-tables-contextmenu-z, 100);
          transform: ${supportsCSSMin
                ? `translateX(min(${e.clientX}px, calc(100vw - 100%)))
              translateY(min(${e.clientY}px, calc(100vh - 100%)))`
                : `translateX(${e.clientX}px) translateY(${e.clientY}px)`};
        `;
            menu.innerHTML = `
          <ul class="drop-down">
            <li id="table-insert-row-up">${t('上边插入行')}</li>
            <li id="table-insert-row-down">${t('下边插入行')}</li>
            <li id="table-insert-column-left">${t('左边插入列')}</li>
            <li id="table-insert-column-right">${t('右边插入列')}</li>
            <div class="menu-split"></div>
            <li id="table-merge-cells">${t('合并单元格')}</li>
            <li id="table-split-cell">${t('拆分单元格')}</li>
            <div class="menu-split"></div>
            <li id="table-delete-row">${t('删除当前行')}</li>
            <li id="table-delete-column">${t('删除当前列')}</li>
            <li id="table-delete">${t('删除表格')}</li>
          </ul>
          <style>
            #exeditor-context-menu .drop-down {
              margin: 0;
              z-index: 1000;
              list-style: none;
              overflow: hidden;
              height: 328px;
              min-width: 140px;
              box-shadow: 0 0 10px 0 rgb(0 0 0 / 6%);
              border: 1px solid #e7e7e7;
              background-color: white;
              border-radius: 4px;
              padding: 0;
            }
            #exeditor-context-menu .menu-split {
              height: 1px;
              background: #e8e8e8;
            }
            #exeditor-context-menu .drop-down li{
              color: black;
              padding: 0px 16px;
              cursor: pointer;
              height: 36px;
              line-height: 36px;
              overflow: hidden;
              box-sizing: border-box;
              display: flex;
              align-items: center;
            }
            #exeditor-context-menu .drop-down li:hover {
                background-color: #f0f0f0;
            }
          </style>
        `;
            const dropDown = menu.querySelector('.drop-down');
            dropDown === null || dropDown === void 0 ? void 0 : dropDown.addEventListener('click', (e) => {
                const target = e.target;
                switch (target.id) {
                    case 'table-insert-column-left':
                        plug.addColumnBefore();
                        break;
                    case 'table-insert-column-right':
                        plug.addColumnAfter();
                        break;
                    case 'table-insert-row-up':
                        plug.addRowBefore();
                        break;
                    case 'table-insert-row-down':
                        plug.addRowAfter();
                        break;
                    case 'table-delete-row':
                        plug.deleteRow();
                        break;
                    case 'table-delete-column':
                        plug.deleteColumn();
                        break;
                    case 'table-delete':
                        plug.deleteTable();
                        break;
                    case 'table-merge-cells':
                        plug.mergeCells();
                        break;
                    case 'table-split-cell':
                        plug.splitCell();
                        break;
                    default:
                        break;
                }
                menu.outerHTML = '';
                plug.editor.focus();
            });
            menu.addEventListener('mouseleave', () => {
                var _a;
                (_a = menu.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(menu);
            });
            document.body.appendChild(menu);
        });
    }
    update(node) {
        if (node.type !== this.node.type)
            return false;
        this.node = node;
        updateColumns(node, this.colgroup, this.table, this.cellMinWidth);
        return true;
    }
    ignoreMutation(record) {
        return (record.type === 'attributes' &&
            (record.target === this.table || this.colgroup.contains(record.target)));
    }
};
export function updateColumns(node, colgroup, table, cellMinWidth, overrideCol, overrideValue) {
    let totalWidth = 0;
    let fixedWidth = true;
    let nextDOM = colgroup.firstElementChild;
    const row = node.firstChild;
    for (let i = 0, col = 0; i < row.childCount; i++) {
        const { colspan, colwidth } = row.child(i).attrs;
        for (let j = 0; j < colspan; j++, col++) {
            const hasWidth = overrideCol === col ? overrideValue : colwidth === null || colwidth === void 0 ? void 0 : colwidth[j];
            const cssWidth = hasWidth ? `${hasWidth}px` : '';
            totalWidth += hasWidth || cellMinWidth;
            if (!hasWidth)
                fixedWidth = false;
            if (!nextDOM) {
                colgroup.appendChild(document.createElement('col')).style.width =
                    cssWidth;
            }
            else {
                if (nextDOM.style.width !== cssWidth)
                    nextDOM.style.width = cssWidth;
                nextDOM = nextDOM.nextElementSibling;
            }
        }
    }
    while (nextDOM) {
        const after = nextDOM.nextElementSibling;
        nextDOM.parentNode.removeChild(nextDOM);
        nextDOM = after;
    }
    if (fixedWidth) {
        table.style.width = `${totalWidth}px`;
        table.style.minWidth = '';
    }
    else {
        table.style.width = '';
        table.style.minWidth = `${totalWidth}px`;
    }
}
//# sourceMappingURL=table-view.js.map